<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="currencyAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group form-position">
                    <label for="users_id" class="form-label">User:</label>
                    <input class="form-control"  :class="checkValidation(classes)" @input="search" name="" v-model="searchQuery" id="searchQuery" />
                    <ul class="form-list" v-if="showResults">
                      <li :value="it.id" v-for="(it, key) in searchResults" :key="key" @click="selectResult(it.email ,it.id)">{{ it.email }}</li>
                    </ul>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="services_id" class="form-label">Services:</label>
                    <select class="form-control" :class="checkValidation(classes)" name="" v-model="formData.service_id" id="services_id">
                      <option :value="it.id" v-for="(it, key) in services" :key="key">{{it.title_l.en}}</option>
                    </select>
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="amount" class="form-label">Amount:</label>
                    <input id="amount" class="form-control" name="amount" v-model="formData.amount" :class="checkValidation(classes)" placeholder="1500" type="text">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="currencies" class="form-label">Currencies:</label>
                    <select class="form-control" :class="checkValidation(classes)" name="" v-model="formData.currency_id" id="currencies">
                      <option :value="it.id" v-for="(it, key) in currencies" :key="key">{{it.name_l.en}}</option>
                    </select>
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" tag="div" class="form-group">
                    <label for="description" class="form-label">Description:</label>
                    <input id="description" class="form-control" name="description" v-model="formData.description" :class="checkValidation(classes)" placeholder="description" type="text">
                  </ValidationProvider>

                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="payment_ways" class="form-label">Payment way:</label>
                    <select class="form-control" :class="checkValidation(classes)" name="" v-model="formData.transaction.payment_way_id" id="payment_ways">
                      <option :value="it.id" v-for="(it, key) in payment_ways" :key="key">{{it.title}}</option>
                    </select>
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
            <div v-if="isEdit === true">
              <ValidationObserver ref="currencyAddForm" id="currencyAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="statuses" class="form-label">Status:</label>
                    <select class="form-control" :class="checkValidation(classes)" name="" v-model="formData.status" id="statuses">
                      <option :value="it.value" v-for="(it, key) in statuses" :key="key">{{it.name}}</option>
                    </select>
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" tag="div" class="form-group">
                    <label for="description" class="form-label">Description:</label>
                    <input id="description" class="form-control" name="description" v-model="formData.description" :class="checkValidation(classes)" placeholder="description" type="text">
                  </ValidationProvider>
                  <ValidationProvider v-if="formData.status === 2"  rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="paid_at" class="form-label">Paid at</label>
                    <input id="paid_at" class="form-control" name="paid_at" v-model="formData.paid_at" :class="checkValidation(classes)" type="datetime-local">
                  </ValidationProvider>

                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const page = 'serviceOrder'
const url = 'service-order'
export default {
  name: 'AddServiceOrder',
  data () {
    return {
      page: page,
      url: url,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      currencies: [],
      statuses: [],
      services: [],
      users: [],
      paid_at: '',
      payment_ways: [],
      searchQuery: '',
      searchResults: [],
      showResults: false,
      formData: {
        transaction: {}
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    this.getCreateData().then((res) => {
      this.statuses = res.statuses
      this.services = res.services
      this.users = res.users
      this.currencies = res.currencies
      this.payment_ways = res.payment_ways
    })
    this.getAllData().then((res) => {
      this.serviceId = res
    })
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.formData = this.itemData
      })
      this.getCreateDataByID({ id: this.cookieId }).then((res) => {
        this.paid_at = res.paid_at
      })
    }
  },
  methods: {
    ...mapActions({
      getAllData: page + '/getAllData',
      getCreateDataByID: page + '/getCreateDataByID',
      getAllCurrency: 'currency/getAllCurrency',
      create: page + '/create',
      update: page + '/update',
      getData: page + '/getData',
      getCreateData: page + '/getCreateData'
    }),
    customLabel (data) {
      return `${data.name_l[this.$i18n.locale]}`
    },
    checkValidation (data) {
      return data
    },
    search () {
      this.searchResults = []
      for (const item of this.users) {
        if (item.email !== null) {
          if (item.email.toLowerCase().includes(this.searchQuery.toLowerCase())) {
            this.searchResults.push(item)
          }
        }
      }
      this.showResults = this.searchResults.length > 0
      if (this.searchQuery === '') {
        this.showResults = false
      }
    },
    selectResult (email, id) {
      this.searchQuery = email
      this.formData.user_id = id
      this.showResults = false
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          // const form = document.getElementById('currencyAddForm')
          // const formData = new FormData(form)
          this.buttonDisable = true
          // formData.append('transaction[payment_way_id]', this.formData.transaction.payment_way_id)
          delete this.formData.currency
          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.data.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.data.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
